import React, { useState } from "react";
import { collection, addDoc} from "firebase/firestore";
import { db, storage } from "../firebase";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { Link } from "react-router-dom";
import { Navigation } from "swiper";

const TeachersDashboard = () => {
   // upload toppers
   const [uploadFileToppers, setUploadFileToppers] = useState("")
    const [classStream, setClassstream] = useState("")
    const [studentName, setStudentName] = useState("")
    const [studentPercentage, setStudentPercentage] = useState("")

  // book pdf upload
  const [uploadFile, setUploadFile] = useState("")
  const [bookName, setBookName] = useState("")
  const [className, setClassName] = useState("")

  const handleUpload = async () => {
      
    if (uploadFile) {
    
      const storageRef = ref(
        storage,
        "update/" + uploadFile.fileName + "/" + Date.now()
      );
      const uploadTask = uploadBytesResumable(storageRef, uploadFile);
  
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // eslint-disable-next-line default-case
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
          }
        },
        (error) => {
          // eslint-disable-next-line default-case
          switch (error.code) {
            case "storage/unauthorized":
              break;
            case "storage/canceled":
              break;
  
            case "storage/unknown":
              break;
          }
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
            await addDoc(collection(db, "syllabusUpload"), {
                pictureUrl: downloadURL,
                bookName,
                className                    
            }).then(()=>{
              window.location.reload(true)
            }); 
          });
        }
      )
    } else {
      alert("Please fill all the details");
    }
  };
 
  const handleToppersUpload = async () => {
    
    if (uploadFileToppers) {
    
      const storageRef = ref(
        storage,
        "update/" + uploadFileToppers.fileName + "/" + Date.now()
      );
      const uploadTask = uploadBytesResumable(storageRef, uploadFileToppers);
  
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // eslint-disable-next-line default-case
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
          }
        },
        (error) => {
          // eslint-disable-next-line default-case
          switch (error.code) {
            case "storage/unauthorized":
              break;
            case "storage/canceled":
              break;
  
            case "storage/unknown":
              break;
          }
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
            await addDoc(collection(db, "toperStudents"), {
                pictureUrl: downloadURL,
                studentName,
                studentPercentage,
                classStream                    
            }).then(()=>{
              window.location.reload(false)
            }); 
          });
        }
      )
    } else {
      alert("Please fill all the details");
    }
  };

  return (
    <div className="min-h-screen">
        <div className="grid lg:grid-cols-3 grid-rows-3">  
          <div className="justify-center m-5">
       <div className="rounded-lg shadow-xl bg-gray-50 w-full">
        <div className="">
            <input type="file" className="py-3 mt-4 ml-4"
                    onChange={(e) => {
                      setUploadFileToppers(e.target.files[0]);
                        }} 
                    />
                 </div>
               <div className="flex flex-col">
                <label>
                  <span>Student Name</span>
                  <input type="text" className="shadow-xl rounded-lg py-2 ml-4 w-56 px-2" 
                  value={studentName}
                  onChange={(e) => {
                    setStudentName(e.target.value);
                             }}
                  />
                  </label>
                  <label>
                  <span>Percentage</span>
                  <input type="text" className="shadow-xl rounded-lg py-2 ml-9 mt-4 w-56 px-2" 
                    value={studentPercentage}
                    onChange={(e) => {
                      setStudentPercentage(e.target.value);
                               }}
                               />
                  </label>
              <label>
                <span>Stream</span>
                  <select
                value={classStream}
                onChange={(e) => {
                  setClassstream(e.target.value);
                           }}
                  className="shadow-xl py-2 ml-16 mt-4 w-56 px-2 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                >
                   <option value="select"> select</option>
                  <option value="10th">10th</option>
                  <option value="12th Science">12th Science</option>
                  <option value="12th Commerce">12th Commerce</option>
                  <option value="12th Arts">12th Arts</option>
                </select>
                </label>
                    </div>
        <div className="p-2 space-x-4 mt-2">
            <button className="bg-green-500 hover:bg-green-600 active:bg-green-700 focus:outline-none focus:ring focus:ring-green-300 px-5 py-2 font-semibold text-white rounded-lg shadow-lg" onClick={handleToppersUpload}>Upload</button>
        </div>
     </div>
          </div>
          <div className="mr-5 ml-5 mb-5 mt-6">
         <div className="justify-center">
         <div className="rounded-lg shadow-xl bg-gray-50  w-full">
           <div className="m-4">
          <div className="text-lg font-bold">Upload Syllabus</div>
            <input type="file" className="py-3 mt-2 ml-4"
                    onChange={(e) => {
                      setUploadFile(e.target.files[0]);
                        }} 
                    />
                 </div>
               <div className="flex flex-col">
                <label>
                  <span>book Name</span>
                  <input type="text" className="shadow-xl rounded-lg py-2 ml-4 w-56 px-2" 
                  value={bookName}
                  onChange={(e) => {
                    setBookName(e.target.value);
                             }}
                  />
                  </label>
              <label>
                <span>Class</span>
                  <select
                value={className}
                onChange={(e) => {
                  setClassName(e.target.value);
                           }}
                  className="shadow-xl py-2 ml-16 mt-4 w-56 px-2 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                >
                   <option value="select"> select</option>
                   <option value="10th">10th</option>
                   <option value="11th/12th">11th/12th</option>
                </select>
                </label>
                    </div>
        <div className="p-2 space-x-4 mt-2">
            <button className="bg-green-500 hover:bg-green-600 active:bg-green-700 focus:outline-none focus:ring focus:ring-green-300 px-5 py-2 font-semibold text-white rounded-lg shadow-lg" onClick={handleUpload}>Upload</button>
        </div>
     </div>
           </div>
         </div>
          <div className="mr-5 ml-5 mb-5 mt-5"> 
          <div className="h-64 w-full mt-5 flex justify-center items-center bg-gray-50 shadow-lg rounded-lg">
          <Link to="../resultStudentTerm1">
          <div 
                  className="justify-center items-center hover:cursor-pointer">
          <img src="../assets/result.png" alt="pic" className="h-32 w-32 mx-auto" />
              <span className=" text-2xl font-bold"
              >Result</span>
            </div>
            </Link>
          </div>
             </div>
            </div>
          </div>
   
    
  );
};

export default TeachersDashboard;
